import { render, staticRenderFns } from "./StageSettings.vue?vue&type=template&id=d355dc6c&"
import script from "./StageSettings.vue?vue&type=script&lang=ts&"
export * from "./StageSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports